module.exports = __webpack_public_path__ + "img/4.082933e6.jpg";